const SubAbas = [
  { label: 'Produtos Farmacêuticos', rota: '/secsaude/produtosdaf/produtos' },
  {
    label: 'Denominações Genéricas',
    rota: '/secsaude/produtosdaf/denominacoes',
  },
  { label: 'Kits de Produtos', rota: '/secsaude/produtosdaf/kits' },
  { label: 'PDPs', rota: '/secsaude/produtosdaf/pdps' },
];

export default SubAbas;
